import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';
import SingleProject from '../views/SingleProject.vue'
import projects from '../data/projects';

const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home,
		meta: {
			title: 'Joseph Valdez - Home',
		},
	},
	{
		path: '/about',
		name: 'About',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ '../views/About.vue'),
		meta: {
			title: 'Joseph Valdez - About',
		},
	},
	{
		path: '/experience',
		name: 'Experience',
		component: () =>
			import('../views/Experience.vue'),
		meta: {
			title: 'Joseph Valdez - Professional Experience',
		},
	},
	{
		path: '/projects',
		name: 'Projects',
		component: () =>
			import('../views/Projects.vue'),
		meta: {
			title: 'Joseph Valdez - Projects',
		},
	},
	{
		path: '/projects/:projectId',
		name: 'Single Project',
		component: SingleProject,
		props: true,
		meta: {
			title: 'Joseph Valdez - Single Project',
		},
	},
	{
		path: '/qualifications',
		name: 'Qualifications',
		component: () =>
			import('../views/Qualifications.vue'),
		meta: {
			title: 'Joseph Valdez - Qualifications',
		},
	},
	{
		path: '/contact',
		name: 'Contact',
		component: () =>
			import('../views/Contact.vue'),
		meta: {
			title: 'Joseph Valdez - Contact',
		},
	},
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
	scrollBehavior() {
		document.getElementById('app').scrollIntoView();
	},
});

export default router;

/**
 * Below code will display the component/active page title
 * Powered by: Nangialai Stoman
 */

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
	// This goes through the matched routes from last to first, finding the closest route with a title.
	// e.g., if we have `/some/deep/nested/route` and `/some`, `/deep`, and `/nested` have titles,
	// `/nested`'s will be chosen.
	const nearestWithTitle = to.matched
		.slice()
		.reverse()
		.find((r) => r.meta && r.meta.title);

	// Find the nearest route element with meta tags.
	const nearestWithMeta = to.matched
		.slice()
		.reverse()
		.find((r) => r.meta && r.meta.metaTags);

	const previousNearestWithMeta = from.matched
		.slice()
		.reverse()
		.find((r) => r.meta && r.meta.metaTags);

	// If a route with a title was found, set the document (page) title to that value.
	if (to.name === 'Single Project') {
		const project = projects.find(
			(item) => String(item.id) === String(to.params.projectId)
		);
		document.title = project
			? `Joseph Valdez - ${project.title}`
			: 'Joseph Valdez - Projects';
	} else if (nearestWithTitle) {
		document.title = nearestWithTitle.meta.title;
	} else if (previousNearestWithMeta) {
		document.title = previousNearestWithMeta.meta.title;
	}

	// Remove any stale meta tags from the document using the key attribute we set below.
	Array.from(
		document.querySelectorAll('[data-vue-router-controlled]')
	).map((el) => el.parentNode.removeChild(el));

	// Skip rendering meta tags if there are none.
	if (!nearestWithMeta) return next();

	// Turn the meta tag definitions into actual elements in the head.
	nearestWithMeta.meta.metaTags
		.map((tagDef) => {
			const tag = document.createElement('meta');

			Object.keys(tagDef).forEach((key) => {
				tag.setAttribute(key, tagDef[key]);
			});

			// We use this to track which meta tags we create so we don't interfere with other ones.
			tag.setAttribute('data-vue-router-controlled', '');

			return tag;
		})
		// Add the meta tags to the document head.
		.forEach((tag) => document.head.appendChild(tag));

	next();
});
